import { Fragment } from 'react'
import { useStaticData } from '@mc/static-data-react'
import { useCourseBySlug } from 'libs/client/api'
import { SubsectionEntities } from 'libs/utils'
import { SUBSECTIONS_TYPE } from 'types'
import { Article } from 'types/data'
import { ArticleSubsections } from 'types/data/Article'
import FeaturedCourseTrailer from '../FeaturedCourseTrailer'
import Content from './Content'

const Subsections = ({
  subsections,
}: {
  subsections: ArticleSubsections[]
}) => {
  const { article } = useStaticData<{ article: Article }>()
  const { courseBySlug, error } = useCourseBySlug(article.featuredCourseSlug)

  return (
    <section>
      {subsections
        .filter(
          (subsection) =>
            subsection.entityType === SubsectionEntities.subsection,
        )
        .map((subsection, index) => (
          <Fragment key={subsection.id}>
            <Content subsection={subsection} />
            {index === 0 &&
              !(subsection.videoId || subsection.mediaUuid) &&
              courseBySlug &&
              !error && <FeaturedCourseTrailer />}
          </Fragment>
        ))}
    </section>
  )
}

Subsections.propTypes = {
  subsections: SUBSECTIONS_TYPE,
}

export default Subsections
